import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { DiagnosticEducatifContext } from "@Providers/DiagnosticEducatifProvider"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"
import { SurveyService } from "@Services/Survey.Service"
import { useContext, useState } from "react"
import { useRecoilValue } from "recoil"

export const useFetchAllAxis = ({ user }) => {
    const { setFetchingDiagEduc, setAxisLastItemIndex } = useContext(DiagnosticEducatifContext)
    const [loading, setLoading] = useState(true)
    const [fetchingResponseByAxeId, setFetchingResponseByAxeId] = useState(false)
    const [responseByAxeId, setResponseByAxeId] = useState([])
    const [data, setData] = useState([])
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)

    const fetchAllAxis = (hasSurvey = undefined) => {
        setFetchingDiagEduc(true)
        setLoading(true)
        EducatifDiagnoseService.getAllAxis(hasSurvey)
            .then((response) => {
                const res = response?.data?.data?.items

                if (res && res instanceof Array) {
                    const items = res
                    // const items = res.slice(0, res?.length - 3)
                    setData(items)
                    setAxisLastItemIndex(items?.length - 1 ?? 0)
                }
                setLoading(false)
                setFetchingDiagEduc(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
                setFetchingDiagEduc(false)
            })
    }

    const DEId = currentEducationalDiagnosis?.id || undefined

    const fetchAllAxisSurveyResponsesById = (axeId) => {
        setFetchingResponseByAxeId(true)
        SurveyService.getSurveyResponsesById(user?.id, axeId, DEId)
            .then((response) => {
                const axisQuestions = response?.data?.data
                const responses = Array.from(axisQuestions, (axisQuestion) => ({
                    id: axisQuestion.id,
                    question: axisQuestion.survey.text,
                    precision: axisQuestion.precision,
                    response: axisQuestion.response,
                    surveyId: axisQuestion?.survey?.id,
                    responseData: axisQuestion
                }))

                setResponseByAxeId(responses ?? [])
                setFetchingResponseByAxeId(false)
            })
            .catch(() => {
                setFetchingResponseByAxeId(false)
            })
    }

    return {
        fetchAllAxis,
        fetchAllAxisSurveyResponsesById,
        loading,
        data,
        fetchingResponseByAxeId,
        responseByAxeId
    }
}
